import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductComparatorComponent } from './product-comparator.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { PageTitle } from '../../store-front/misc/page-title/page-title.component';
import { ProductComparatorItemComponent } from './components/product-comparator-item/product-comparator-item.component';
import { productComparatorOccConfig } from './core/product-comparator.occ';

@NgModule({
  declarations: [ProductComparatorComponent],
  imports: [
    CommonModule,
    PageTitle,
    ProductComparatorItemComponent,
    I18nModule,
    RouterModule.forChild([
      {
        path: 'products-compare',
        component: PageLayoutComponent,
        data: { pageLabel: 'products-compare' },
        canActivate: [CmsPageGuard],
      },
    ]),
  ],
  providers: [
    provideConfig(productComparatorOccConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        productComparator: {
          component: ProductComparatorComponent,
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          productsComparator: { paths: ['products-compare'] },
        },
      },
    }),
  ],
})
export class ProductComparatorModule {}